import gql from "graphql-tag";

export const GET_LIST_VALUES = gql`
  query($listId: String, $listName: String, $listType: String) {
    getListValues(listId: $listId, listName: $listName, listType: $listType) {
      statusCode
      message
      data
    }
  }
`;
